import React from 'react'

interface ModalCloseButtonProps {
  onClick: () => void
  className?: string
  ariaLabel?: string
}

export const ModalCloseButton: React.FC<ModalCloseButtonProps> = ({
  onClick,
  className = 'message-reviewer-modal__close',
  ariaLabel = 'Close'
}) => (
  <button
    type='button'
    className={className}
    aria-label={ariaLabel}
    onClick={onClick}
  >
    <i className='fa-solid fa-xmark' aria-hidden='true' />
  </button>
)
